export const BENCHMARK_PLANS = 'benchmark-plans'

export const benchmarkPlansPath = (): string => `/${BENCHMARK_PLANS}`
